import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logoImage from '../Header/images/AnnaLogo.svg';
import lizardLaptopImage from './images/lizard_laptop.svg';

import styles from './MobilePopup.module.css';

export default class MobilePopup extends Component {
  render() {
    const { onOkClick } = this.props;
    return (
      <div className={styles.wrapper}>
        <div className={styles.main}>
          <img src={logoImage} className={styles.logo} alt="anna_logo" />
          <div className={styles.center}>
            <img src={lizardLaptopImage} className={styles.illustration} alt="lizard_laptop" />
            <div className={styles.text}>
              Please be aware that this form is
              <br />
              currently developed only for desktop
              <br />
              view, so your experience on mobile
              <br />
              won&apos;t be as smooth.
            </div>
            <div className={styles.subtext}>
              We recommend using your mobile for
              <br />
              the app and a computer for this form.
            </div>
          </div>
          <div className={styles.button} onClick={onOkClick}>Continue</div>
        </div>
      </div>
    );
  }
}

MobilePopup.propTypes = {
  onOkClick: PropTypes.func.isRequired,
};
